import _ from 'lodash';
import DepsService from 'services/dependencies';
import { evalMeta } from 'utils/grid/grid';
import {
  getEmailListForRetailer,
  getReportListForRetailer,
  getSftpListForRetailer,
  saveEmailListForRetailer,
  saveReportListForRetailer,
  saveSftpListForRetailer,
} from 'report-subscriptions/resources/report-subscriptions-api';

/* Redux */
const namespace = 'reportSubscriptionsPage';
export const SET_REPORTS = `${namespace}_SET_REPORTS`;
export const SET_EMAILS = `${namespace}_SET_EMAILS`;
export const SET_RECIPIENTS_EMAIL = `${namespace}_SET_RECIPIENTS_EMAIL`;
export const SET_SFTP = `${namespace}_SET_SFTP`;
export const SET_SUBSCRIPTIONS_REPORTS = `${namespace}_SET_SUBSCRIPTIONS_REPORTS`;
export const SET_SUBSCRIPTIONS_EMAIL = `${namespace}_SET_SUBSCRIPTIONS_EMAIL`;
export const SET_SUBSCRIPTIONS_SFTP = `${namespace}_SET_SUBSCRIPTIONS_SFTP`;
export const SET_IS_LOADING_REPORTS = `${namespace}_SET_IS_LOADING_REPORTS`;
export const SET_IS_LOADING_EMAIL = `${namespace}_SET_IS_LOADING_EMAIL`;
export const SET_IS_LOADING_SFTP = `${namespace}_SET_IS_LOADING_SFTP`;

/* consts */
const REPORT_SUBSCRIPTIONS_CONTEXT = 'sftp';
export const SUBSCRIPTION_TYPE_RETAILER = 'RETAILER';
export const SUBSCRIPTION_TYPE_GROUP = 'GROUP';

const createObjectByFileTypeId = (array) =>
  array.reduce((reduced, item) => {
    // eslint-disable-next-line no-param-reassign
    item.transformations = item.transformations.reduce((newTransformations, transform) => {
      // eslint-disable-next-line no-param-reassign
      newTransformations[transform.transformType] = transform;
      return newTransformations;
    }, {});
    // eslint-disable-next-line no-param-reassign
    reduced[item.fileTypeId] = item;
    return reduced;
  }, {});

const applySubscriptionData = (data) => ({
  gridData: _.cloneDeep(data.subscriptions || data),
  subscriptions: createObjectByFileTypeId(data.subscriptions || data),
  recipients: data.externalEmails || [],
});

export const loadReportList = (retailerIdParam, retailerTypeParam) => (dispatch, getState) => {
  const {
    session: {
      retailer: { retailerId: retailerIdSession, retailerType: retailerTypeSession },
    },
  } = getState();
  const retailerId = retailerIdParam || retailerIdSession;
  const retailerType = retailerTypeParam || retailerTypeSession;
  const promise = getReportListForRetailer(retailerId, retailerType);

  dispatch({
    type: SET_IS_LOADING_REPORTS,
  });

  return promise.then((result) => {
    const newData = applySubscriptionData(result);
    dispatch({
      type: SET_REPORTS,
      payload: {
        items: newData.gridData,
        meta: evalMeta(result),
      },
    });

    dispatch({
      type: SET_SUBSCRIPTIONS_REPORTS,
      payload: newData.subscriptions,
    });
  });
};

export const loadEmailList = (retailerIdParam, retailerTypeParam) => (dispatch, getState) => {
  const {
    session: {
      retailer: { retailerId: retailerIdSession, retailerType: retailerTypeSession },
    },
  } = getState();
  const retailerId = retailerIdParam || retailerIdSession;
  const retailerType = retailerTypeParam || retailerTypeSession;
  const promise = getEmailListForRetailer(retailerId, retailerType);

  dispatch({
    type: SET_IS_LOADING_EMAIL,
  });

  return promise.then((result) => {
    const newData = applySubscriptionData(result);
    dispatch({
      type: SET_EMAILS,
      payload: {
        items: newData.gridData,
        meta: evalMeta(result),
      },
    });

    dispatch({
      type: SET_SUBSCRIPTIONS_EMAIL,
      payload: newData.subscriptions,
    });

    dispatch({
      type: SET_RECIPIENTS_EMAIL,
      payload: newData.recipients,
    });
  });
};

export const loadSftpList = (retailerIdParam, retailerTypeParam) => (dispatch, getState) => {
  const {
    session: {
      retailer: { retailerId: retailerIdSession, retailerType: retailerTypeSession },
    },
  } = getState();
  const retailerId = retailerIdParam || retailerIdSession;
  const retailerType = retailerTypeParam || retailerTypeSession;
  const promise = getSftpListForRetailer(retailerId, retailerType);

  dispatch({
    type: SET_IS_LOADING_SFTP,
  });

  return promise.then((result) => {
    const newData = applySubscriptionData(result);

    dispatch({
      type: SET_SFTP,
      payload: {
        items: newData.gridData,
        meta: evalMeta(result),
      },
    });

    dispatch({
      type: SET_SUBSCRIPTIONS_SFTP,
      payload: newData.subscriptions,
    });
  });
};

export const saveReportList = (retailerIdParam) => (dispatch, getState) => {
  const {
    session: {
      retailer: { retailerId: retailerIdSession },
    },
    reportSubscriptionsPage: { subscriptionsReports },
  } = getState();
  const retailerId = retailerIdParam || retailerIdSession;
  return saveReportListForRetailer(retailerId, subscriptionsReports);
};

export const saveEmailList = (retailerIdParam) => (dispatch, getState) => {
  const {
    session: {
      retailer: { retailerId: retailerIdSession },
    },
    reportSubscriptionsPage: { subscriptionsEmail, recipients },
  } = getState();
  const retailerId = retailerIdParam || retailerIdSession;
  return saveEmailListForRetailer(retailerId, subscriptionsEmail, recipients);
};

export const saveSftpList = (retailerIdParam) => (dispatch, getState) => {
  const {
    session: {
      retailer: { retailerId: retailerIdSession },
    },
    reportSubscriptionsPage: { subscriptionsSftp },
  } = getState();
  const retailerId = retailerIdParam || retailerIdSession;
  return saveSftpListForRetailer(retailerId, subscriptionsSftp);
};

export const applyRecipient = (recipient) => (dispatch, getState) => {
  const {
    reportSubscriptionsPage: { recipients },
  } = getState();

  dispatch({
    type: SET_RECIPIENTS_EMAIL,
    payload: _.uniq(recipients.concat(recipient)),
  });
};

export const removeRecipient = (recipient) => (dispatch, getState) => {
  const {
    reportSubscriptionsPage: { recipients },
  } = getState();

  dispatch({
    type: SET_RECIPIENTS_EMAIL,
    payload: recipients.filter((oldRecipient) => oldRecipient !== recipient),
  });
};

export const unsubscribeUser = (token) => () =>
  DepsService.restSrv.create(REPORT_SUBSCRIPTIONS_CONTEXT, DepsService.rest.report.unsubscribe.url, {
    token,
  });



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/actions/report-subscriptions-page.actions.js